import React, { useState, useEffect, useRef } from 'react';
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Container from "@mui/material/Container";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import { HiOutlineSearch } from "react-icons/hi";
import { FiUser } from "react-icons/fi";
import wishlistIcon from "../assests/wishlistIcon.png";
import cartIcon from "../assests/cartIcon.png";
import logo from "../assests/Logo.png";
import "./Header.css";
import { useProductStore } from '../store/useProductStore';
import { useAuthStore } from '../store/useAuthStore';
import { useCartStore } from '../store/useCartStore';
import SideMenu from './SideMenu';
import SearchDropdown from '../components/ProductSearch/ProductSearch';
import QueryModal from './ProductSearch/QueryModal';
import { useQueryStore } from '../store/useQueryStore';
import Loader from './Loader/Loader';


const SubNav = () => {
  const { authUser } = useAuthStore();
  const { postQuery } = useQueryStore()
  const { totalCartItem } = useCartStore();
  const { getAllProduct } = useProductStore();

  const [openQueryFormModal, setOpenQueryFormModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);

  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const dropdownRef = useRef(null);
  const menuRef = useRef(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    setOpen(!!value);
  };

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const getSearchProduct = async () => {
    await getAllProduct(1, 10, search, 'name');
  };

  const handleSubmit = async (data) => {
    try {
      setLoading(true)
      const res = await postQuery(data)
      setLoading(false)
      setOpenQueryFormModal(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }

  };

  useEffect(() => {
    getSearchProduct();
  }, [search]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setOpen(false);
      }

      if (
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setIsVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static" sx={{ backgroundColor: "#2B3463", padding: "10px 0" }}>
          <Container maxWidth="xl">
            <Toolbar
              className="p-0"
              sx={{ padding: "0 !important", justifyContent: "space-between" }}
            >
              <Box sx={{ display: "flex", alignItems: "center", padding: 0 }}>
                <Link to="/">
                  <img
                    src={logo}
                    alt="Logo"

                  />
                </Link>
              </Box>

              {/* Search Input and Dropdown */}
              <Box ref={dropdownRef}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "40%",
                  position: "relative",
                  background: "#fff",
                  borderRadius: "4px",
                  border: "2px solid #89C9FF",
                  height: "45px",
                  padding: "0 15px",
                  "& .searchInput": { width: "80%" },
                  "& .searchInput input": {
                    border: "none",
                    padding: "4px 0px",
                    width: "100%",
                  },
                  "& input:focus-visible": { outline: "none" },
                  "& .searchInputIcon": {
                    position: "absolute",
                    right: "20px",
                  },
                  "& .searchInputIcon svg": {
                    color: "#838383",
                    fontSize: "20px",
                  },
                }}
              >
                <span className="searchInput">
                  <input
                    type="text"
                    placeholder="Search for items..."
                    onChange={handleChange}
                    value={search}
                  />
                </span>
                <span className="searchInputIcon">
                  <HiOutlineSearch />
                </span>

                {search && open && (
                  <SearchDropdown
                    open={open}
                    loading={false}
                    setOpen={setOpen}
                    setSearch={setSearch}
                    setOpenQueryFormModal={setOpenQueryFormModal}
                  />
                )}

                {/* </div> */}
              </Box>

              <QueryModal
                open={openQueryFormModal}
                handleClose={() => setOpenQueryFormModal(false)}
                onSubmit={handleSubmit}
                loading={loading}
              />
              {/* Right Side Buttons */}
              <Box sx={{ display: { xs: "none", md: "flex" }, marginLeft: "20px" }}>
                {/* Cart Button */}
                <IconButton aria-label="cart" color="inherit">
                  <Button
                    component={Link}
                    to="/cart"
                    sx={{
                      my: 0,
                      color: "#fff",
                      display: "flex",
                      textTransform: "none",
                      fontFamily: `"Lato", sans-serif`,
                      fontWeight: 400,
                      fontSize: "16px",
                      lineHeight: "16px",
                      margin: 0,
                    }}
                  >
                    <span className="navInfonum" style={{ marginRight: "10px" }}>
                      <img src={cartIcon} alt="Cart" />
                      <span>{totalCartItem}</span>
                    </span>
                    Cart
                  </Button>
                </IconButton>

                {/* Account / Login */}
                {authUser ? (
                  <IconButton color="inherit">
                    <Button
                      onClick={toggleVisibility}
                      sx={{
                        my: 0,
                        color: "#fff",
                        display: "flex",
                        textTransform: "none",
                        fontFamily: `"Lato", sans-serif`,
                        fontWeight: 400,
                        fontSize: "16px",
                        lineHeight: "16px",
                        margin: 0,
                      }}
                    >
                      <span className="navInfonum" style={{ marginRight: "10px" }}>
                        {authUser?.avatar ? (
                          <img
                            src={authUser.avatar}
                            alt="Avatar"
                            style={{
                              height: "40px",
                              width: "40px",
                              borderRadius: "50%",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <FiUser size={40} style={{ borderRadius: "50%", backgroundColor: "#f3f4f6", padding: "8px" }} />
                        )}
                      </span>
                      {authUser?.fullName}
                    </Button>
                    {isVisible && (
                      <Box
                        ref={menuRef}
                        sx={{
                          position: "absolute",
                          top: "55px",
                          right: 0,
                          zIndex: "99",
                          width: "max-content",
                        }}
                      >
                        <SideMenu />
                      </Box>
                    )}
                  </IconButton>
                ) : (
                  <IconButton color="inherit">
                    <Button
                      component={Link}
                      to="/login"
                      sx={{
                        my: 0,
                        color: "#fff",
                        display: "flex",
                        textTransform: "none",
                        fontFamily: `"Lato", sans-serif`,
                        fontWeight: 400,
                        fontSize: "16px",
                        lineHeight: "16px",
                        margin: 0,
                      }}
                    >
                      <span className="navInfonum" style={{ marginRight: "10px" }}>
                        <FiUser />
                      </span>
                      Login
                    </Button>
                  </IconButton>
                )}
              </Box>
            </Toolbar>
          </Container>
        </AppBar>
      </Box>
    </>
  );
};

export default SubNav;
